/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Audio_BlockedInputs */

const vi_station_audio_blocked = /** @type {(inputs: Station_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạm màn hình để bật tiếng`)
};

/**

* @param {Station_Audio_BlockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_audio_blocked = /** @type {((inputs?: Station_Audio_BlockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Audio_BlockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_audio_blocked(inputs)
});